import React from 'react';
import { Skeleton } from '@components/ui/skeleton';
const RegionSwitcherSkeleton: React.FC = () => <div className="relative z-10 w-[140px] sm:w-[150px] lg:w-[130px] xl:w-[150px]" data-sentry-component="RegionSwitcherSkeleton" data-sentry-source-file="region-switcher-loader.tsx">
    <div className="
        border border-neutral-200 dark:border-neutral-700
        bg-neutral-100 dark:bg-neutral-800
        rounded-lg shadow-md
        flex items-center justify-between px-3 py-2
        animate-pulse
      ">
      <div className="flex items-center">
        <Skeleton className="h-5 w-5 rounded-full" data-sentry-element="Skeleton" data-sentry-source-file="region-switcher-loader.tsx" />
        <Skeleton className="ml-2 h-4 w-12 rounded" data-sentry-element="Skeleton" data-sentry-source-file="region-switcher-loader.tsx" />
      </div>
      <Skeleton className="h-5 w-5 rounded-full" data-sentry-element="Skeleton" data-sentry-source-file="region-switcher-loader.tsx" />
    </div>
  </div>;
export default React.memo(RegionSwitcherSkeleton);